var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5",staticStyle:{"max-height":"100vh","overflow":"auto"}},[_c('h6',{staticClass:"my-10"},[_vm._v(_vm._s(_vm.$t('PRIVACY.DISPLAY.TITLE')))]),(_vm.projectBrandObject[13].value == 2)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.projectBrandObject[13].decodedOptions.message)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }